import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["secondary", "onClose", "primaryLabelStyles"];
import React from 'react';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import CrossButton from '../cross-button';
import Styled from './modal-title.styles';
import { Variant } from './types';
var ModalTitle = intrinsicComponent(function (_ref, ref) {
  var secondary = _ref.secondary,
    onClose = _ref.onClose,
    primaryLabelStyles = _ref.primaryLabelStyles,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.ModalTitle, _extends({}, rest, {
    ref: ref
  }), rest.icon && /*#__PURE__*/React.createElement(Styled.Icon, {
    iconShadow: Boolean(rest.iconShadow)
  }, rest.icon), /*#__PURE__*/React.createElement(Styled.LabelPrimary, {
    variant: rest.variant,
    style: primaryLabelStyles
  }, rest.primary), rest.variant === Variant.WithIcon && secondary && /*#__PURE__*/React.createElement(Styled.LabelSecondary, null, secondary), /*#__PURE__*/React.createElement(Styled.Close, {
    variant: rest.variant
  }, /*#__PURE__*/React.createElement(CrossButton, {
    size: "lg",
    onClick: onClose
  })));
});
ModalTitle.defaultProps = {
  iconShadow: true,
  variant: Variant.Default
};
ModalTitle.propTypes = {
  primary: PT.node.isRequired,
  secondary: PT.node,
  icon: PT.node,
  iconShadow: PT.bool,
  onClose: PT.func,
  primaryLabelStyles: PT.object,
  variant: PT.oneOf(objectValues(Variant))
};
ModalTitle.displayName = 'ModalTitle';
export default ModalTitle;